import { adminService } from '../services'

const state = {
  all: {
    loading: false,
    items: [],
    error: null
  },
  updating: false,
  updateError: null,
  registering: false,
  registerError: null
}

const actions = {
  getUsers ({ commit }) {
    commit('getUsersRequest')

    adminService.getUsers()
      .then(
        users => commit('getUsersSuccess', users),
        error => commit('getUsersFailure', error)
      )
  },
  updateUserRole ({ commit }, { userId, payload }) {
    commit('updateUserRoleRequest')

    return adminService.updateUserRole(userId, payload)
      .then(
        () => {
          commit('updateUserRoleSuccess', { userId, payload })
          return Promise.resolve()
        },
        error => {
          commit('updateUserRoleFailure', error)
          return Promise.reject(error)
        }
      )
  },
  registerUser ({ commit }, payload) {
    commit('registerUserRequest')

    return adminService.registerUser(payload)
      .then(
        () => {
          commit('registerUserSuccess')
          return Promise.resolve()
        },
        error => {
          commit('registerUserFailure', error)
          return Promise.reject(error)
        }
      )
  }
}

const mutations = {
  getUsersRequest (state) {
    state.all = { loading: true, items: [] }
  },
  getUsersSuccess (state, users) {
    state.all = { loading: false, items: users }
  },
  getUsersFailure (state, error) {
    state.all = { loading: false, error, items: [] }
  },
  updateUserRoleRequest (state) {
    state.updating = true
    state.updateError = null
  },
  updateUserRoleSuccess (state, { userId, payload }) {
    state.updating = false
    const index = state.all.items.findIndex(user => user._id === userId)
    if (index !== -1) {
      // Create a new user object to ensure reactivity
      const updatedUser = { ...state.all.items[index], ...payload }

      // Update the user item in the array using Vue.set equivalent for Vuex
      state.all.items.splice(index, 1, updatedUser)
    }
  },
  updateUserRoleFailure (state, error) {
    state.updating = false
    state.updateError = error
  },
  registerUserRequest (state) {
    state.registering = true
    state.registerError = null
  },
  registerUserSuccess (state) {
    state.registering = false
  },
  registerUserFailure (state, error) {
    state.registering = false
    state.registerError = error
  }
}

export const admin = {
  namespaced: true,
  state,
  actions,
  mutations
}
